import jsPDF from 'jspdf';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalSilla from '../components/ModalSilla'
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import logo from '../assets/gorion.png' // Ruta a tu logo
import './Servicios.css';
import axios from 'axios';
const moment = require('moment-timezone');


const ServicePage = () => {


  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : {};
  const estacionUsuario = decoded.estacion?.trim().toUpperCase() || 'Estación no especificada';


  const user = JSON.parse(localStorage.getItem('user')) || {};
  const [formData, setFormData] = useState({
    fechaInput: new Date().toISOString().split('T')[0], // Fecha actual
    estacion: user.estacion || 'Estación no especificada',
    horaInicio: new Date().toLocaleTimeString('en-GB', { hour12: false }),
    usuarioInicio: user.noColaborador || 'Sin usuario',
    noColaborador:'',
    qr: '',
    sillaRuedas: '',
    observaciones: 'REGISTRO PARCIAL LLEGADAS',
    eta: '',
    tipoSilla: 'WCHR',
    servicioSolicitado: 'P. ATENCION',
    tipoVuelo: 'CONTACTO',
    origen: 'RESERVACION',
    nombrePax: '',
    noVuelo: '',
    aerolinea: '',
    noAsiento: '',
    origenVuelo: '',
    destinoVuelo: '',
  });
  const [isModalAsignarOpen, setIsModalAsignarOpen] = useState(false);
  const [colaboradores, setColaboradores] = useState([]); // Datos de colaboradores en turno
  const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchColaborador, setSearchColaborador] = useState('');
    const [vuelosDisponibles, setVuelosDisponibles] = useState([]);

  
  const [isModalSillaOpen, setIsModalSillaOpen] = useState(false);

  const handleSillaAsignada = (nfcData) => {
    setFormData((prev) => ({ ...prev, sillaRuedas: nfcData }));
  };
  const fetchVuelosPorEstacion = async () => {
    try {
      const fechaHoy = new Date().toISOString().split('T')[0];
      const response = await axios.get(
        `https://orionadministracion.com/api/vuelos?fecha=${fechaHoy}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setVuelosDisponibles(response.data);
    } catch (error) {
      console.error('Error al cargar vuelos:', error);
    }
  };
  


  useEffect(() => {
    const interval = setInterval(() => {
      setFormData((prevData) => ({
        ...prevData,
        horaInicio: new Date().toLocaleTimeString('en-GB', { hour12: false }),
      }));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  

  useEffect(() => {
    fetchVuelosPorEstacion();
  }, []);
  

  

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleGeneratePDF = async () => {

    try{
      const response = await axios.get(`https://orionadministracion.com/api/operadores/${formData.noColaborador}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Incluye el token
        }
      });
      const operadorAsign = response.data;
  
      // Crear un documento PDF
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [58, 120], // 58mm de ancho, altura variable
    });
  
    // Agregar logo
    doc.addImage(logo, 'PNG', 4, 4, 50, 20); // X, Y, Ancho, Alto

    //Fecha del servicio
      doc.setFontSize(12)
      doc.text(`Fecha: ${moment().tz('America/Mexico/City').format('YYYY-MM-DD HH:mm:ss')}`, 4, 30)
  
    // Agregar detalles del ticket
    doc.setFontSize(10);
    doc.text(`Aerolinea: ${formData.aerolinea}`, 4, 35);
    doc.text(`No. Vuelo: ${formData.noVuelo}`, 4, 40);
    doc.text(`Operador: ${operadorAsign.nombre} ${operadorAsign.apellidos} - ${formData.noColaborador}`, 4, 45);
    doc.text(`No. TIA: ${operadorAsign.tia || '2502432'}`, 4, 50);
    doc.text(`Silla: ${formData.sillaRuedas}`, 4, 55);
  
    // Mensaje final
    doc.setFontSize(12);
    doc.text('------------------------------------------', 4, 60);
    doc.text('La calidad en el servicio nos caracteriza,', 4, 65);
    doc.text('Servicio gratuito', 4, 70);
    doc.setFontSize(9);
    doc.text('Quejas: 55-2729-1171', 4, 75);
    doc.setFontSize(12);
    doc.text('-----------------------------------------', 4, 80);
    doc.text('-----------------------------------------', 4, 85);
    doc.text('-----------------------------------------', 4, 90);
  
  
  
    // Abrir el PDF en una nueva pestaña
    const pdfURL = doc.output('bloburl');
    window.open(pdfURL, '_blank');
    }catch{
      toast.error('Error al registrar el servicio', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
    
  };

  const fetchOperatorDetails = async () => {
    try {
      const response = await axios.get(
        `https://orionadministracion.com/api/operadores/${formData.noColaborador}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // Actualiza datos faltantes en formData
      setFormData((prev) => ({
        ...prev,
        siglas: response.data.siglas,
        tia: response.data.tia,
      }));
    } catch (error) {
      console.error('Error al obtener los detalles del operador:', error);
      toast.error('Error al obtener los detalles del operador');
    }
  };

  const abrirModalAsignar = async () => {
    setIsModalAsignarOpen(true);
    try {
      const response = await axios.get(
        'https://orionadministracion.com/api/bitacora/en-turno-detalles',
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const colaboradoresFiltrados = response.data.filter(
  (c) => c.estacion?.trim().toUpperCase() === estacionUsuario
);
setColaboradores(colaboradoresFiltrados);

    } catch (error) {
      console.error('Error al obtener colaboradores en turno con detalles:', error);
      setColaboradores([]);
    }
  };

  const seleccionarColaborador = (colaborador) => {
    setFormData((prev) => ({
      ...prev,
      noColaborador: colaborador.noColaborador,
    }));
    setIsModalAsignarOpen(false);
    fetchOperatorDetails();
  };

  // Filtrar colaboradores por nombre o siglas en el modal de asignación
  const filteredColaboradores = searchColaborador.trim()
  ? colaboradores
      .filter((colaborador) => {
        const searchLower = searchColaborador.toLowerCase();
        const siglas = colaborador.siglas ? colaborador.siglas.toLowerCase() : '';
        return siglas.includes(searchLower);
      })
      .slice(0, 1)
  : [];
  
  
  
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Datos enviados al servidor:', formData); // Agregar esta línea

    // Validar campos obligatorios
  if (!formData.noVuelo) {
    toast.error('El campo "Número de Vuelo" es obligatorio.', {
      position: 'top-right',
      autoClose: 3000,
    });
    return;
  }
    try {
      const response = await axios.post(
        'https://orionadministracion.com/api/servicios/parcial',
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',

          },
        }
      );
      toast.success('Servicio registrado correctamente', {
        position: 'top-right',
        autoClose: 3000,
      });
      // Generar y abrir el PDF
    handleGeneratePDF();

    setTimeout(() => {
      window.location.reload(); // Cierra el modal
    }, 3000);
      console.log(response.data);
    } catch (error) {
      console.error('Error al registrar el servicio:', error);
      toast.error('Error al registrar el servicio', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const aerolineasPorEstacion = {
    GDL: ['AA', 'AM', 'DL', 'UA'],
    PVR: ['AM', 'CNT', 'DL', 'UA', 'FFT', 'TAR', 'ACA', 'SW', 'FLE'],
    DEFAULT: ['AA', 'AM', 'DL', 'UA'], // Para otras estaciones
  };
  
  const aerolineasDisponibles = aerolineasPorEstacion[estacionUsuario] || aerolineasPorEstacion.DEFAULT;

  
  
  
  
  
  

  return (
    <div className="service-page">
      <ToastContainer />
      <h3>Estación actual: {estacionUsuario}</h3>

      <h1>Registro de Servicios Llegadas</h1>

      

      {/* Modal para escaneo de silla */}
      {isModalSillaOpen && (
  <ModalSilla
    onClose={() => setIsModalSillaOpen(false)}
    onSillaAsignada={handleSillaAsignada}
  />
)}
     {isModalAsignarOpen && (
        <div
          className="modal-overlay"
          onClick={() => setIsModalAsignarOpen(false)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Asignar a Colaborador</h2>
            <input
              type="text"
              placeholder="Buscar por nombre o siglas..."
              value={searchColaborador}
              onChange={(e) => setSearchColaborador(e.target.value)}
              className="form-control"
              style={{ marginBottom: '10px' }}
            />
            <ul className="colaboradores-list">
              {filteredColaboradores.map((colaborador) => (
                <li
                  key={colaborador.noColaborador}
                  onClick={() => seleccionarColaborador(colaborador)}
                  className={`colaborador-item ${
                    colaborador.noFila === 1 ? 'recomendado' : ''
                  }`}
                >
                  {`#Fila: ${colaborador.noFila}, Colaborador: ${colaborador.noColaborador} (${colaborador.siglas}), Nombre: ${colaborador.nombreCompleto}`}
                  {colaborador.noFila === 1 && (
                    <span className="badge">Recomendado</span>
                  )}
                </li>
              ))}
            </ul>
            <button
              className="btn-close"
              onClick={() => setIsModalAsignarOpen(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}


      {/* Formulario */}
      <form className="service-form" onSubmit={handleSubmit}>
        {/* Campos de Pase de Abordar */}

        <div className="form-group">
  <label>Vuelos del Día</label>
  <select
    value={`${formData.aerolinea}-${formData.noVuelo}`}
    onChange={(e) => {
      const [aerolinea, noVuelo] = e.target.value.split('-');
      setFormData((prev) => ({
        ...prev,
        aerolinea,
        noVuelo
      }));
    }}
    className="form-control"
  >
    <option value="">Selecciona un vuelo</option>
    {vuelosDisponibles.map((vuelo) => (
      <option key={vuelo.idvuelo} value={`${vuelo.aerolinea}-${vuelo.noVuelo}`}>
        {`${vuelo.aerolinea} - ${vuelo.noVuelo}`}
      </option>
    ))}
  </select>
</div>
      


  
        <div className="form-group">
    <label>Fecha</label>
    <input
      type="text"
      name="fechaInput"
      value={formData.fechaInput}
      readOnly
      className="form-control"
    />
  </div>
  
  <div className="form-group">
    <label>Hora de Inicio</label>
    <input
      type="text"
      name="horaInicio"
      value={formData.horaInicio}
      readOnly
      className="form-control"
    />
  </div>
  
  <div className="form-group">
    <label>Asignar a:</label>
    <input
      type="text"
      name="noColaborador"
      value={formData.noColaborador}
      readOnly
      className="form-control"
    />
    <button type="button" className="btn-camera" onClick={abrirModalAsignar}>
              Asignar
            </button>
  </div>
  <div className="form-group">
    <label>Silla de Ruedas</label>
    <div className="input-group">
      <input
        type="text"
        name="sillaRuedas"
        value={formData.sillaRuedas}
        readOnly
        className="form-control"
      />
      <button
  type="button"
  className="btn-camera"
  onClick={() => setIsModalSillaOpen(true)}
>
  Escanear NFC silla
</button>

    </div>
  </div>
  <div className="form-group">
    <label>Observaciones</label>
    <input
      type="text"
      name="observaciones"
      value={formData.observaciones}
      onChange={handleInputChange} // Aquí se usa correctamente
      className="form-control"
    />
  </div>
  
        {/* Agregar todos los campos como antes */}
        {/* ... */}
        <button type="submit" className="btn-submit">
          Registrar Servicio
        </button>
      </form>
    </div>
  );
};

export default ServicePage;